module.exports = __webpack_public_path__ + "media/styles/images/svg/arrow-left-white-tall-a6e6e35561912cf7d5c427b75b76cb3b.svg";